module.exports = "/images/clickpay.svg?7dd84a799b3f3194068b41007ecb00b9";